@import '../../../../../style/lib/scss';
@import '../../../../../style/src/typography/mixins';
@import '../../../mixins/outline';

:host {
	@include zds-typography('body');

	display: flex;
}

.zds-navigation-link__icon--custom {
	zds-icon,
	::slotted([slot='icon']) {
		display: block;
		font-size: 35px;
	}
}

.zds-navigation-link {
	$this: &;

	@include outline;

	align-items: center;
	color: var(--zds-navigation-link-color);
	cursor: pointer;
	display: inline-flex;
	gap: var(--zds-space-2);
	min-height: 38px;
	text-decoration: none;
	text-transform: var(--zds-navigation-link-text-transform);

	&--active {
		color: var(--zds-navigation-link-color-active);
	}

	&:hover {
		color: var(--zds-navigation-link-color-hover);
	}

	&__label {
		font-family: var(--zds-navigation-link-font-family);
		font-size: var(--zds-navigation-link-size);
		font-weight: var(--zds-navigation-link-font-weight);
	}

	&__icon {
		&--type-custom {
			zds-icon,
			::slotted([slot='icon-start']),
			::slotted([slot='icon-end']) {
				display: block;
				font-size: 26px;
			}
		}

		&--type-chevron {
			display: flex;
			transition: transform var(--zds-transition-md);
		}
	}

	&--active &__icon--type-chevron {
		transform: rotate(180deg);
	}
}
